import { Fragment, jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import "./treegrid.script";
const TreegridRows = ({
  rows
}) => /* @__PURE__ */jsx(Fragment, {
  children: rows.map(row => /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("div", {
      class: "rui-treegrid__row",
      role: "row",
      "data-row-id": row.id,
      "aria-expanded": row.children?.length ? row.expanded ?? false : void 0,
      children: row.cells.map((cell, index) => /* @__PURE__ */jsx("div", {
        class: "rui-treegrid__cell",
        role: "gridcell",
        tabindex: -1,
        "data-col": index,
        "aria-selected": "false",
        children: cell
      }))
    }), row.children?.length ? /* @__PURE__ */jsx("div", {
      class: "rui-treegrid__group",
      role: "rowgroup",
      hidden: !(row.expanded ?? false),
      children: /* @__PURE__ */jsx(TreegridRows, {
        rows: row.children
      })
    }) : null]
  }))
});
export function RuiTreegrid({
  columns,
  rows,
  label,
  children,
  ...props
}) {
  const content = columns != null && rows != null ? /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("div", {
      class: "rui-treegrid__row rui-treegrid__row--header",
      role: "row",
      children: columns.map(column => /* @__PURE__ */jsx("div", {
        class: "rui-treegrid__cell rui-treegrid__cell--header",
        role: "columnheader",
        children: column
      }))
    }), /* @__PURE__ */jsx(TreegridRows, {
      rows
    })]
  }) : children;
  return /* @__PURE__ */jsx("rui-treegrid", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-treegrid",
      "data-ref": "root",
      role: "treegrid",
      "aria-label": label || void 0,
      children: content
    })
  });
}